function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Ewma } from './ewma';
export var EwmaBandwidthEstimator = /*#__PURE__*/ function() {
    "use strict";
    function EwmaBandwidthEstimator() {
        _class_call_check(this, EwmaBandwidthEstimator);
        _define_property(this, "fast", new Ewma(2));
        _define_property(this, "slow", new Ewma(5));
        _define_property(this, "bytesSampled", 0);
        _define_property(this, "minTotalBytes", 128e3);
        // 128kb
        _define_property(this, "minBytes", 16e3);
    }
    _create_class(EwmaBandwidthEstimator, [
        {
            key: "configure",
            value: // 16kb
            function configure(config) {
                this.minTotalBytes = config.minTotalBytes;
                this.minBytes = config.minBytes;
                this.fast.updateAlpha(config.fastHalfLife);
                this.slow.updateAlpha(config.slowHalfLife);
            }
        },
        {
            key: "getBandwidthEstimate",
            value: function getBandwidthEstimate(defaultEstimate) {
                if (this.bytesSampled < this.minTotalBytes) {
                    return defaultEstimate;
                }
                // Take the minimum of these two estimates.  This should have the effect
                // of adapting down quickly, but up more slowly.
                return Math.min(this.fast.getEstimate(), this.slow.getEstimate());
            }
        },
        {
            key: "sample",
            value: function sample(durationMs, numBytes) {
                if (numBytes < this.minBytes) {
                    return;
                }
                var bandwidth = 8000 * numBytes / durationMs;
                var weight = durationMs / 1000;
                this.bytesSampled += numBytes;
                this.fast.sample(weight, bandwidth);
                this.slow.sample(weight, bandwidth);
            }
        },
        {
            key: "hasGoodEstimate",
            value: function hasGoodEstimate() {
                return this.bytesSampled >= this.minTotalBytes;
            }
        }
    ]);
    return EwmaBandwidthEstimator;
}();

//# sourceMappingURL=ewma-bandwidth-estimator.js.map